import type { ReactNode } from "react";

interface PageHeaderProps {
  eyebrow: string;
  title: string;
  description: ReactNode;
}

/**
 * Shared header band used by the calculator, payslip and bulk pages.
 * Keeps spacing, borders and typography consistent in one place.
 */
export function PageHeader({ eyebrow, title, description }: PageHeaderProps) {
  return (
    <section className="border-b border-[#DCE3EA] bg-white">
      <div className="mx-auto max-w-[1440px] px-5 py-12 sm:px-8 lg:px-12 lg:py-16">
        <div className="grid gap-6 lg:grid-cols-[280px_1fr]">
          <div>
            <p className="mono text-[10px] uppercase tracking-[.13em] text-[#2348C7]">{eyebrow}</p>
            <h1 className="font-[var(--font-source-serif)] mt-3 text-3xl leading-tight tracking-[-.02em]">
              {title}
            </h1>
          </div>
          <div>
            <p className="max-w-3xl text-[15px] leading-7 text-slate-600">{description}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
